import { MsalGuard, MsalInterceptor } from '@azure/msal-angular';
import { CanActivateFn } from '@angular/router';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { ISS_AUTH_GUARD, ISS_AUTH_SERVICE } from '../auth.config';
import { provideIssSupportLink } from '../../../../../wo-common/src/lib/components/contact-support/contact-support.config';

import { MsalAuthService } from './msal-auth.service';

export function msalAuthProviders(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true,
    },
    {
      provide: ISS_AUTH_GUARD,
      useFactory: (guard: MsalGuard): CanActivateFn => (route, state) => guard.canActivate(route, state),
      deps: [ MsalGuard ],
    },
    {
      provide: ISS_AUTH_SERVICE,
      useClass: MsalAuthService,
    },
    provideIssSupportLink('https://jira.issworld.com/plugins/servlet/desk/portal/25/create/2314'),
  ]);
}
